import { render, staticRenderFns } from "./BaseFormTagInput.vue?vue&type=template&id=24b99e4f&scoped=true"
import script from "./BaseFormTagInput.vue?vue&type=script&lang=js"
export * from "./BaseFormTagInput.vue?vue&type=script&lang=js"
import style0 from "./BaseFormTagInput.vue?vue&type=style&index=0&id=24b99e4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b99e4f",
  null
  
)

export default component.exports